/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["i.fa[_ngcontent-%COMP%]{font-size:1.25rem;left:-.125rem;opacity:.65;position:absolute;top:-.25rem}a[_ngcontent-%COMP%]{color:#ff6000;font-weight:700}"];
export { styles as styles };
//# sourceMappingURL=writing-feedback-request-button.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/writing-feedback-request-button/writing-feedback-request-button.component.scss.shim.ngstyle.js
// module id = 1461
// module chunks = 27 28 29